export default {
  ELogType: {
    VIEW: 0,
    DOWNLOAD: 1,
    CHECKIN: 2,
    CHECKOUT: 3,
    NEWDOCUMENT: 4,
    // GROUPCHANGE: 8,
    USERCHANGE: 9,
    // LISTCHANGE: 10,
    // ADDITIONALFIELDCHANGE: 11,
    DOCUMENTTYPECHANGE: 12,
    FOLDERCHANGE: 13,
    // REPOSITORYCHANGE: 14,
    // SUPPORTTICKET: 15,
    LOGIN: 16,
    SEARCH: 17,
    TRASH: 18,
    OBSOLETE: 19,
    // REPLACEFILE: 20,
    PUBLICLINK: 21,
    UPDATEPROPERTIES: 22,
    // LINKEDREVISIONS: 23,
    // SYSTEMCONFIGURATION: 24,
    // REPORT: 25,
    SIGNATURE: 26,
    // OLDREVISION: 27,
    // SENDDOCUMENT: 28,
    FAVORITES: 29,
    // ACTIVESCHECKOUTS: 30,
    // SHAREDDOCUMENTS: 31,
    // SHAREDREVISIONS: 32,
    // INDEXEDPAGES: 33,
    // USERSACTIVEORINACTIVE: 34,
    // WORKFLOWRUN: 35,
    // ADDITIONALFIELDS: 36,
    // INVENTORY: 37,
    // EXPIREDOCUMENT: 38,
    // ADDITIONALFIELD: 39,
    // USERLOGVIEWS: 40,
    // WORKFLOWCHANGE: 41,
    // DOCUMENTD4SIGN: 42,
    REPLACE: 49,
    EDITFOLDER: 50,
    CREATEFOLDER: 51
  },
};
